import {Provider} from 'react-redux';
import {ConfigProvider} from 'antd'
import zhCN from 'antd/es/locale/zh_CN';
import {BrowserRouter} from "react-router-dom";


import store from "./redux";
import './assets/scss/index.scss'
import './App.scss'

import Router from './router'
import {useEffect} from "react";


function App() {


    return (
        <Provider store={store}>
            <ConfigProvider locale={zhCN}>
                <BrowserRouter>
                    <Router/>
                </BrowserRouter>
            </ConfigProvider>
        </Provider>
    );
}

export default App;
